import { render, staticRenderFns } from "./view12.vue?vue&type=template&id=0d010098&scoped=true"
import script from "./view12.vue?vue&type=script&lang=js"
export * from "./view12.vue?vue&type=script&lang=js"
import style0 from "./view12.vue?vue&type=style&index=0&id=0d010098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d010098",
  null
  
)

export default component.exports